/** Overrides + snapshot -> customized SKU prices, via the part 1 engine (the
 *  only rounding point). Per-SKU cost overrides shadow componentCostMicros for
 *  that SKU's pricing pass only; an integration override reprices every SKU. */
import { CatalogSnapshot, priceSku } from './engine';
import { PricingOverrides } from '../domain/PricingOverrides';

export function applyOverrides(snap: CatalogSnapshot, o: PricingOverrides): {
  customPriceDollars: Record<string, number>; customSkus: Set<string>;
} {
  const customPriceDollars: Record<string, number> = {};
  const customSkus = new Set<string>();
  const intBp = o.integrationBp ?? snap.integrationBp;
  const skus = o.integrationBp !== null
    ? Object.keys(snap.compositions)
    : Object.keys(o.componentCosts).filter(s => snap.compositions[s]);
  for (const sku of skus) {
    const perSku = o.componentCosts[sku] || {};
    const shadowed: CatalogSnapshot = {
      ...snap, integrationBp: intBp,
      componentCostMicros: { ...snap.componentCostMicros, ...perSku },
    };
    customPriceDollars[sku] = priceSku(sku, shadowed).discountCents / 100;
    customSkus.add(sku);
  }
  return { customPriceDollars, customSkus };
}
